const LINKS = [
  ["The Device", "light-modes"],
  ["Science", "light-spectrum"],
  ["The Glow", "editorial-features"],
  ["Why It's Better", "comparison-section"],
  ["Results", "transformations"],
  ["Reviews", "testimonials-section"],
  ["Pricing", "price-anchor"],
  ["FAQ", "faq-block"],
];

const go = (tid) => {
  const el = document.querySelector(`[data-testid="${tid}"]`);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const JumpNav = () => (
  <div className="sticky top-[63px] z-30 border-b border-[#F2E8E6] bg-[#FFFCFA]/90 backdrop-blur-md" data-testid="jump-nav">
    <div className="mx-auto flex max-w-[1400px] gap-2 overflow-x-auto px-6 py-3 md:justify-center md:px-12 [&::-webkit-scrollbar]:hidden">
      {LINKS.map(([label, tid]) => (
        <button key={tid} onClick={() => go(tid)} data-testid={`jump-${tid}`}
          className="flex-none rounded-full border border-[#F2E8E6] bg-white px-4 py-1.5 text-xs font-medium uppercase tracking-wider text-[#2C2B2C] transition-all hover:border-[#FBC4A8] hover:bg-[#FBC4A8]">
          {label}
        </button>
      ))}
    </div>
  </div>
);
